import { GuestNavbar } from '@/components/GuestNavbar/GuestNavbar'
import { Box } from '@mantine/core'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/guest')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Box className="guest-layout">
      <GuestNavbar></GuestNavbar>
      <Outlet></Outlet>
      <Box hiddenFrom="sm" h="100px"></Box>
    </Box>
  )
}
